import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	deviceList: [],
	selectedDevice: null
};

const deviceSelectionSlice = createSlice({
	name: `device`,
	initialState,
	reducers: {
		setDeviceList: (state, action) => {
			state.deviceList = action.payload;
		},
		setSelectedDevice: (state, action) => {
			state.selectedDevice = action.payload;
		}
	}
});

export const { setDeviceList, setSelectedDevice } = deviceSelectionSlice.actions;

export default deviceSelectionSlice.reducer;
